import React, { Fragment } from 'react'

import numeral from 'numeral'

import PropTypes from 'prop-types'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

import JobReportButton from './JobReportButton'
import JobInfoRow from '../../../Profile/JobsDashboard/Components/JobInfoRow'
import MessageFiles from '../../../Shared/Messaging/Components/MessageFiles'
import MessageImages from '../../../Shared/Messaging/Components/MessageImages'
import UserAvatar from '../../../Shared/UserAvatar/UserAvatar'
import CommissionNotice from '../../Shared/CommissionNotice'

function ProjectDetails({
  data,
  jobId,
  files = EMPTY_ARRAY,
  images = EMPTY_ARRAY,
  skillsFilterOptions,
  softwareFilterOptions,
}) {
  const imageAltText = `${data.software.join(' ')} ${data.skills.join(' ')} ${data.title} freelance 3d modeling job`.replace(/  +/g, ' ').truncate(122)

  return (
    <Fragment>
      {!data.isViewerDesigner && (
        <CommissionNotice audience="buyer" />
      )}
      <div className="project-heading">
        <h1 className="heading-24">
          {data.title}
        </h1>
        <a href={`/${data.author.username}`} className="project-heading__avatar" target="_blank">
          <UserAvatar
            img={data.author.avatar_url}
            userName={data.author.username}
            isWithName
          />
        </a>
        <JobReportButton jobId={jobId} />
        <span className="u-float-right heading-24">{numeral(data.budget).format('$0')}</span>
      </div>

      <p className="project-description" dangerouslySetInnerHTML={{ __html: data.description }} />

      <div className="job-list-item__row job-list-item__row--bottom project-details">
        <JobInfoRow
          type={data.type}
          deadline={data.deadline || undefined}
          isResellable={data.isResellable}
          software={data.software}
          skills={data.skills}
          status={data.status}
          isApplicationCountVisible={data.type === 'public'}
          applicationCount={data.applicationCount}
          isPublicListing={false}
          isViewerDesigner={data.isViewerDesigner}
          skillsFilterOptions={skillsFilterOptions}
          softwareFilterOptions={softwareFilterOptions}
          withLinks
        />
      </div>

      {(files.length !== 0 || images.length !== 0) && (
        <div className="job-attachments">
          <h2 className="heading-18">Additional files</h2>
          <div className="message__attachments">
            <div className="row">
              <MessageImages attachments={images} imageAltText={imageAltText} />
              <MessageFiles files={files} />
            </div>
          </div>
        </div>
      )}
    </Fragment>
  )
}

ProjectDetails.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    author: PropTypes.shape({
      avatar_url: PropTypes.string,
      username: PropTypes.string.isRequired,
    }),
    budget: PropTypes.number.isRequired,
    description: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    deadline: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    isResellable: PropTypes.bool.isRequired,
    isViewerDesigner: PropTypes.bool,
    software: PropTypes.array.isRequired,
    skills: PropTypes.array.isRequired,
    status: PropTypes.string.isRequired,
  }).isRequired,
  jobId: PropTypes.string.isRequired,
  files: PropTypes.array,
  images: PropTypes.array,
}

export default ProjectDetails
